import {LAYERDIV} from './LayerDivTypes'

const initialState = {
    layerDiv : {}
}

const LayerDivReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case LAYERDIV:
            
            return {
                layerDiv : action.load
            }
    
        default:
          return state
    }

}

export default LayerDivReducer;